export default "__VITE_ASSET__C9BbJz_R__"